import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ConfigurationService } from '../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class IncomeStatementService {
  incomeUrl = this.ConfigService.getAPIBaseUrl() + 'api/IncomeStatement'
  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }

  getIncomeStatement(APPeriodId) {
    return this.http.get(this.incomeUrl + '/GetIncomeStatement?APPeriodId=' + APPeriodId);
  }
}
